import Phase10OrderPage from './Phase10OrderPage';

export default function EmailSetupOrderPage() {
  return <Phase10OrderPage skuCode="email-setup" />;
}
